import { collectionsTransformer } from 'apis/transformers/collections'
import { recipesTransformer } from 'apis/transformers/recipes'
import { locationQuery } from 'selectors/routing'

import { actionTypes } from './actionTypes'

export function menuCollectionsReceive(collections) {
  return {
    type: actionTypes.MENU_COLLECTIONS_RECEIVE,
    collections,
  }
}

export function menuReceiveMenu(recipes) {
  return {
    type: actionTypes.RECIPES_RECEIVE,
    recipes,
  }
}

const basketCurrentMenuIdChange = ({ id, attributes }) => ({
  type: actionTypes.BASKET_CURRENT_MENU_ID_CHANGE,
  menuId: id,
  menuUuid: attributes.uuid,
})

function getStockAvailability(getState, recipeStock) {
  const { recipes } = getState()
  const query = locationQuery(getState())
  const isAdminLink = query && query['preview[menu_id]']
  const storedRecipes = Object.values(recipes.toJS())
  const recipeStockList = Object.values(recipeStock)

  if (isAdminLink) {
    return storedRecipes.reduce((acc, recipe) => {
      acc[recipe.id] = {
        1: 1000,
        2: 1000,
        4: 1000,
        committed: false,
      }

      return acc
    }, {})
  }

  return recipeStockList.reduce((acc, stockEntry) => {
    const committed = stockEntry.committed === '1'

    const recipe = storedRecipes.find((obj) => obj.id === stockEntry.recipeId.toString())

    if (recipe) {
      acc[recipe.id] = {
        1: 1000,
        2: committed ? parseInt(stockEntry.number, 10) : 1000,
        4: committed ? parseInt(stockEntry.familyNumber, 10) : 1000,
        committed,
      }
    }

    return acc
  }, {})
}

const loadMenuCollectionsWithMenuService = async (dispatch, getState) => {
  const state = getState()
  const menuServiceData = state.menuService

  if (!menuServiceData || !menuServiceData.data || !menuServiceData.data.length) {
    return
  }

  const activeMenu = menuServiceData.data[0]
  const transformedCollections = collectionsTransformer(activeMenu, menuServiceData)
  const transformedRecipes = recipesTransformer(activeMenu, menuServiceData)

  dispatch(menuCollectionsReceive(transformedCollections))
  dispatch(menuReceiveMenu(transformedRecipes))
  dispatch(basketCurrentMenuIdChange(activeMenu))
}

const mapRecipesAvailabilityToStock = (recipesAvailability, isAdmin) =>
  recipesAvailability.reduce((recipes, { recipeId, portions }) => {
    const recipeAvailability = Object.entries(portions).reduce(
      (availability, [portion, { available }]) => ({
        ...availability,
        [portion]: available || isAdmin ? 1000 : 0,
      }),
      {},
    )

    return {
      ...recipes,
      [recipeId]: recipeAvailability,
    }
  }, {})

export { getStockAvailability, loadMenuCollectionsWithMenuService, mapRecipesAvailabilityToStock }
